/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Flex,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  useSteps,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import Loader from "../../../components/PageLoader";
import BreadCrumb from "../../../components/breadCrumb";
import { Paths } from "../../../routes/paths";
import { useAddCustomer } from "../../../services/customer-api";
import {
  useLookupCurrency,
  useLookupDesignations,
} from "../../../services/lookups-queries";
import { emptyCustomer } from "../constants";
import Insurance from "./insurance";
import Contracts from "./contracts";
import ReplenishmentModels from "./replenishment-models";
import ContactPerson from "./contact-persons";
import Accounts from "./accounts";
import CustomerInformation from "./customer-information";
import OfferedServices from "./offered-services";
import EscalationGroups from "./escalation-groups";
import Summary from "./summary";

const steps = [
  { title: "Information" },
  { title: "Accounts" },
  { title: "Contacts" },
  { title: "Insurance" },
  { title: "Models" },
  { title: "Contracts" },
  { title: "Offered Services" },
  { title: "Escalations" },
];
export default function AddCustomer() {
  const [triggerValidation, setTriggerValidation] = useState(false);
  const [designationList, setDesignationList] = useState([]);
  const [customer, setCustomer] = useState({ ...emptyCustomer });
  const { activeStep, setActiveStep } = useSteps({
    index: 1,
    count: steps.length,
  });
  const navigate = useNavigate();

  const { data: currencyListRes, isPending: gettingCurrencyList } =
    useLookupCurrency();
  // const { data: countries, isPending: gettingCountryList, error: countryError } = useLookupCountries();

  const { data: designations, isPending: gettingDesignations } =
    useLookupDesignations();
  const {
    mutate: createRequest,
    isSuccess: isRequestCreated,
    isPending: creatingRequest,
  } = useAddCustomer();

  useEffect(() => {
    if (isRequestCreated) {
      navigate(Paths.customers);
      return;
    }

    if (designations?.data) {
      setDesignationList(
        designations.data.map((des) => ({
          id: des.description,
          text: des.description,
        }))
      );
    }
  }, [isRequestCreated, designations]);

  const updateCustomerInfo = (information) => {
    const _customer = {
      ...customer,
      clientId: information.clientId,
      name: information.name,
      shortName: information.shortName,
      customerType: information.customerType,
      customerCode: information.customerCode,
      status: information.status,
      hasSeparateDispenseCount: information.hasSeparateDispenseCount,
      requiresEVhr: information.requiresEVhr,
    };
    setCustomer(_customer);
  };

  const getCustomerInformation = useMemo(
    () => ({
      clientId: customer.clientId,
      name: customer.name,
      shortName: customer.shortName,
      customerType: customer.customerType,
      customerCode: customer.customerCode,
      status: customer.status,
      hasSeparateDispenseCount: customer.hasSeparateDispenseCount,
      requiresEVhr: customer.requiresEVhr,
    }),
    [customer]
  );

  const updateAccounts = (accounts) => {
    const _customer = {
      ...customer,
      accounts,
    };
    setCustomer(_customer);
  };

  const getAccounts = useMemo(() => [...customer.accounts], [customer]);

  const updateContactPersons = (contactPersons) => {
    const _customer = {
      ...customer,
      contactPersons,
    };
    setCustomer(_customer);
  };

  const getContactPersons = useMemo(
    () => [...customer.contactPersons],
    [customer]
  );

  const updateReplenishmentModels = (replenishmentModels) => {
    const _customer = {
      ...customer,
      replenishmentModels,
    };
    setCustomer(_customer);
  };

  const getReplenishmentModels = useMemo(
    () =>
      customer.replenishmentModels.map((elm) => ({ ...elm, expanded: false })),
    [customer]
  );

  const updateInsuranceLimits = (insuranceLimits) => {
    const _customer = {
      ...customer,
      insuranceLimits,
    };
    setCustomer(_customer);
  };

  const getInsuranceLimits = useMemo(
    () => [...customer.insuranceLimits],
    [customer]
  );
  const updateContracts = (contracts) => {
    const _customer = {
      ...customer,
      contracts,
    };
    setCustomer(_customer);
  };

  const getContracts = useMemo(() => [...customer.contracts], [customer]);

  const getOfferedServices = useMemo(
    () => [...customer.offeredServices],
    [customer]
  );
  const updateServices = (services) => {
    const _customer = {
      ...customer,
      offeredServices: services,
    };
    setCustomer(_customer);
  };
  const getEscalationGroups = useMemo(
    () => [...customer.escalationGroups],
    [customer]
  );
  const updateEscalationGroup = (escalationGroups) => {
    const _customer = {
      ...customer,
      escalationGroups,
    };
    setCustomer(_customer);
  };
  const {
    handleSubmit,
    control,
    trigger,
    watch,
    resetField,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: { ...getCustomerInformation },
  });
  useEffect(() => {
    if (activeStep === 1 && triggerValidation) {
      trigger();
    } else if (activeStep !== 1 && triggerValidation) {
      setTriggerValidation(false);
    }
  }, [triggerValidation, activeStep]);
  return (
    <>
      {creatingRequest || gettingCurrencyList || gettingDesignations ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Customers", link: Paths.customers },
            { text: "Create Customer", isCurrentPage: true },
          ]}
        />

        <Stepper index={activeStep} size="sm" className="extra-small-stepper">
          {steps.map((step, index) => (
            <Step
              key={index}
              onClick={() => {
                if (activeStep === 1) {
                  updateCustomerInfo(getValues());
                }
                setActiveStep(index + 1);
              }}
            >
              <StepIndicator style={{ cursor: "pointer" }}>
                <StepStatus
                  complete={<StepIcon />}
                  incomplete={<StepNumber />}
                  active={<StepNumber />}
                />
              </StepIndicator>

              <div style={{ cursor: "pointer" }}>
                <StepTitle>{step.title}</StepTitle>
                <StepDescription>{step.description}</StepDescription>
              </div>

              <StepSeparator />
            </Step>
          ))}
        </Stepper>

        <Flex w="100%" mt="20px">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <div className="add-location-form">
                {activeStep === 1 ? (
                  <form>
                    <CustomerInformation
                      customerObject={getCustomerInformation}
                      onNextStep={() => {
                        setActiveStep(2);
                        updateCustomerInfo(getValues());
                      }}
                      handleSubmit={handleSubmit}
                      control={control}
                      errors={errors}
                      watch={watch}
                      resetField={resetField}
                    />
                  </form>
                ) : activeStep === 2 ? (
                  <Accounts
                    accounts={getAccounts}
                    onNextStep={(localAccountsList) => {
                      setActiveStep(3);
                      updateAccounts(localAccountsList);
                    }}
                    onPrevStep={(localAccountsList) => {
                      setActiveStep(1);
                      updateAccounts(localAccountsList);
                    }}
                    addData={(data) => {
                      updateAccounts(data);
                    }}
                  />
                ) : activeStep === 3 ? (
                  <ContactPerson
                    designationList={designationList}
                    contactPersons={getContactPersons}
                    onNextStep={(contactPersonList) => {
                      setActiveStep(4);
                      updateContactPersons(contactPersonList);
                    }}
                    onPrevStep={(contactPersonList) => {
                      setActiveStep(2);
                      updateContactPersons(contactPersonList);
                    }}
                    addData={(data) => {
                      updateContactPersons(data);
                    }}
                  />
                ) : activeStep === 4 ? (
                  <Insurance
                    currencies={currencyListRes?.data || []}
                    insuranceLimits={getInsuranceLimits}
                    onNextStep={(insuranceLimit) => {
                      setActiveStep(5);
                      updateInsuranceLimits(insuranceLimit);
                    }}
                    onPrevStep={(insuranceLimit) => {
                      setActiveStep(3);
                      updateInsuranceLimits(insuranceLimit);
                    }}
                    addData={(data) => {
                      updateInsuranceLimits(data);
                    }}
                  />
                ) : activeStep === 5 ? (
                  <ReplenishmentModels
                    currencies={currencyListRes?.data || []}
                    models={getReplenishmentModels}
                    onNextStep={(replenishmentModels) => {
                      setActiveStep(6);
                      updateReplenishmentModels(replenishmentModels);
                    }}
                    onPrevStep={(replenishmentModels) => {
                      setActiveStep(4);
                      updateReplenishmentModels(replenishmentModels);
                    }}
                    addData={(data) => {
                      updateReplenishmentModels(data);
                    }}
                  />
                ) : activeStep === 6 ? (
                  <Contracts
                    contracts={getContracts}
                    currencies={currencyListRes?.data || []}
                    onPrevStep={(contracts) => {
                      setActiveStep(5);
                      updateContracts(contracts);
                    }}
                    onNextStep={(contracts) => {
                      setActiveStep(7);

                      updateContracts(contracts);
                    }}
                    addData={(data) => {
                      updateContracts(data);
                    }}
                  />
                ) : activeStep === 7 ? (
                  <OfferedServices
                    services={getOfferedServices}
                    currencies={currencyListRes?.data || []}
                    onPrevStep={(services) => {
                      setActiveStep(6);
                      updateServices(services);
                    }}
                    onNextStep={(services) => {
                      setActiveStep(8);
                      updateServices(services);
                    }}
                    addData={(data) => {
                      updateServices(data);
                    }}
                  />
                ) : activeStep === 8 ? (
                  <EscalationGroups
                    escalationGroups={getEscalationGroups}
                    onPrevStep={(escalationGroups) => {
                      setActiveStep(7);
                      updateEscalationGroup(escalationGroups);
                    }}
                    onNextStep={(escalationGroups) => {
                      updateEscalationGroup(escalationGroups);
                      if (isValid) {
                        setActiveStep(9);
                      } else {
                        setActiveStep(1);
                        setTriggerValidation(true);
                      }
                    }}
                    addData={(data) => {
                      updateEscalationGroup(data);
                    }}
                  />
                ) : activeStep === 9 ? (
                  <Summary
                    customer={customer}
                    onPrevStep={() => {
                      setActiveStep(8);
                    }}
                    onCreateCustomer={(customerPayload) => {
                      createRequest({ ...customerPayload });
                    }}
                  />
                ) : (
                  <></>
                )}

                {/* <Flex
                    w={"100%"}
                    justify={"flex-end"}
                    flexDirection={"row"}
                    onClick={() => {
                      if (activeStep < 6) {
                        setActiveStep(activeStep + 1);
                      }
                    }}
                  >
                    <Button type={activeStep === 6 ? "submit" : ""}>{activeStep === 6 ? "Submit" : "Next"}</Button>
                  </Flex> */}
              </div>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
